import { createSelector } from 'reselect';

import { parentSelector } from '../../selectors/parentSelector';

export const getAvailableCategories = createSelector(parentSelector, (state) => state.data.availableCategories);
